import { environment } from 'src/environments/environment';

const server = environment.API;
const BASE_URL = server;
const BASE_FILE_UPLOAD = environment.UPLOADS_DIR;
const PATH_IMAGE = BASE_FILE_UPLOAD + '/products/';
const PATH_THUMB = PATH_IMAGE + 'thumbs/';
const PATH_CATEGORIES = BASE_FILE_UPLOAD + '/categories/'
const PATH_TERMS = BASE_FILE_UPLOAD + '/regulamentos/'
const PATH_CATALOGO = BASE_FILE_UPLOAD + '/catalogo/'
const PATH_ORDEM = BASE_FILE_UPLOAD + '/ordem/'
const PATH_BANNERS = BASE_FILE_UPLOAD + '/banners/'
const SOCKET_API = environment.SOCKET_URL;
const USER_DOCS_PATH = server + '/uploads/documentos/';
const APP_VERSION = '2.25.0';

// general config
const CLIENT_NAME = 'XR Leilões'
// const LOGO_PATH = ''
const COLORS = {
    HEADER: '#45a65a'
}
const LOGO_PATH = '../assets/images/logo.png'
const FAVICON_PATH = '../assets/images/favicon-en.ico'

const SPINNER_CONFIG = {
    TYPE: 'timer',
    SIZE: 'default'
}

export default {
    BASE_URL,
    PATH_IMAGE,
    PATH_THUMB,
    CLIENT_NAME,
    LOGO_PATH,
    FAVICON_PATH,
    PATH_CATEGORIES,
    PATH_TERMS,
    PATH_CATALOGO,
    PATH_ORDEM,
    SPINNER_CONFIG,
    PATH_BANNERS,
    COLORS,
    SOCKET_API,
    APP_VERSION,
    USER_DOCS_PATH
};
